<template>
  <v-dialog
      v-model="showDialog"
      persistent
      max-width="320"
      data-cy="pod-deleted-dialog"
  >
    <template v-slot:activator="{ props }">
      <div v-bind="props" data-cy="pod-deleted-activator">
        <slot></slot>
      </div>
    </template>

    <v-card data-cy="pod-deleted-card">
      <v-card-title class="d-flex justify-space-between">
        <span>
          {{ $t('routes.pod.fileDeleted') }}
        </span>

        <v-btn icon @click="closeAndRedirect" :aria-label="$t('common.close')" data-cy="close-dialog-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-body-1 py-4">
        {{ $t('routes.pod.OKforRedirect') }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="closeAndRedirect"
            data-cy="redirect-btn"
        >
          {{ $t('common.redirect') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useNodeStore } from '@/stores/NodeStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["input"],
  name: 'PodDeletedDialog',
  mixins: [DialogActionKeys],

  props: {
    shouldShowDeletedPodDialog: {
      type: Boolean,
      required: true
    },
    pod: {
      type: Object,
      required: true,
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.shouldShowDeletedPodDialog;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    closeAndRedirect() {
      const podStore = usePodStore();
      podStore.setViewPodDeleted(false);

      const nodeStore = useNodeStore();
      const isActiveNode = nodeStore.isActiveNode(this.pod.nodeid);

      if (isActiveNode) {
        this.$router.push(`/node/${this.pod.nodeid}`);
      } else {
        const nodeStore = useNodeStore();
        const activeParentNodeId = nodeStore.findActiveParentNodeIdOfDeletedNode(this.pod.nodeid);

        if (activeParentNodeId) {
          this.$router.push(`/node/${activeParentNodeId}`);
        } else {
          this.$router.push('/');
        }
      }
    }
  }
};
</script>

<style scoped>
.v-card__text {
  font-size: 16px !important;
}
</style>
